<template>
    <button class="db-card-filter-btn dropdown-btn">
        <i class="lab lab-line-import lab-font-size-17"></i>
        <span>{{ $t('button.import') }}</span>
    </button>
</template>

<script>
export default {
    name: "ImportComponent"
}
</script>